import axios from "axios";
import {
    CreateMarketplaceItemRequest,
    MarketplaceItem,
    UpdateMarketplaceItemRequest,
    UploadInSituResponse,
    Workflow
} from "./types";
import {AxiosRequestConfig} from "openapi-client-axios";

export const auth = {
    token: ""
}

const client = axios.create({
    baseURL:String(process.env.REACT_APP_API_URL),
})

client.interceptors.request.use(
    (config)=>{
        config.headers.setAuthorization("Bearer " +auth.token, true)
        return config
    }
)

class Service {
    static Client = client;
    static getWorkflows() {
        return client.get<Workflow[]>('my/workflows').then(r=>r.data)
    }
    static getWorkflowItem(workflowId:string){
        return client.get<Workflow>(`my/workflows/${workflowId}`).then(r=>r.data)
    }
    static startWorkflow(workflowId:string) {
        const conf: AxiosRequestConfig = {
            headers:{
                "Content-Type" : "text/plain"
            }
        }
        return client.get<boolean>(`my/workflows/${workflowId}/start`, conf).then(r=>true)
    }
    static stopWorkflow(workflowId:string) {
        return client.get<boolean>(`my/workflows/${workflowId}/stop`).then(r=>true)
    }
    static deleteWorkflow(workflowId:string) {
        return client.delete<boolean>(`my/workflows/${workflowId}`).then(r=>true)
    }
    static getMarketplace() {
        return client.get<MarketplaceItem[]>('marketplace').then(r=>r.data)
    }
    static getMarketplaceItem(itemId:string) {
        return client.get<MarketplaceItem>(`marketplace/${itemId}`).then(r=>r.data)
    }
    static deleteMarketplaceItem(itemId:string) {
        return client.delete<boolean>(`marketplace/${itemId}`).then(r=>true)
    }
    static postMarketplaceItem(item:CreateMarketplaceItemRequest) {
        return client.post<MarketplaceItem>('marketplace', item).then(r=>r.data)
    }
    static updateMarketplaceItem(itemId:string, item:UpdateMarketplaceItemRequest) {
        return client.put<MarketplaceItem>(`marketplace/${itemId}`, item).then(r=>r.data)
    }
    static patchMarketplaceItem(itemId:string, item:Partial<UpdateMarketplaceItemRequest>) {
        return client.patch<MarketplaceItem>(`marketplace/${itemId}`, item).then(r=>true)
    }
    static createMarketplaceItem(item:CreateMarketplaceItemRequest) {
        return client.post<MarketplaceItem>('marketplace', item).then(r=>r.data)
    }
    static uploadInsituData(workflowId:string, file:File, metaData:string) {
        const formData = new FormData()
        formData.append("file", file)
        formData.append("metaData", metaData)
        return client.post<UploadInSituResponse>(`data/insitu/${workflowId}/upload`, formData).then(r=>r.data)
    }
    static uploadInsituProduct(workflowId:string, file:File) {
        const formData = new FormData()
        formData.append("file", file)
        return client.post<UploadInSituResponse>(`data/insitu/${workflowId}/upload-product`, formData).then(r=>r.data)
    }
    static deleteInsituProduct(workflowId:string, fileName:string) {
        return client.post(`data/insitu/${workflowId}/delete-product`, {fileName}).then(r=>true)
    }

}

export default Service
